$(document).ready(function(){
    $('.index-slider').slick({
        prevArrow: $(".index-slider__arrow-prev"),
        nextArrow: $(".index-slider__arrow-next"),
        variableWidth: true,
        slidesToShow: 4,
        infinite: false,
        responsive: [
            {
              breakpoint: 1360,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 956,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 625,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrow: false
              }
            }
          ]
    });
  });